import MyTable from 'components/UIElements/MyTable';

export default function NoLogin({ endPoint, exportFilename }) {
  const columns = [
    {
      title: 'PolicyNo',
      key: 'policyNo',
      dataIndex: 'policyNo'
    },
    {
      title: 'MacAddress',
      key: 'macAddress',
      dataIndex: 'macAddress'
    }
  ];

  return (
    <MyTable
      columns={columns}
      endPoint={endPoint}
      exportFilename={exportFilename}
    />
  );
}
